module.exports = __webpack_public_path__ + "static/media/469JamesPBrawleyDrNW_2018-06-12_87.14025efc.jpg";